import * as React from "react";
import { LocalizedText } from "bernie-l10n";
import { classNames } from "uitk-react-utils";
import { locKeys } from "src/components/flexComponents/WizardHotelPWA/components/l10n";
import { useHotelsContext } from "components/flexComponents/Hotels/components/HotelsContext";

export const LegalText = ({ className }: { className?: string }) => {
  const {
    flexComponent: {
      model: { showLegalText },
    },
  } = useHotelsContext();

  if (!showLegalText) {
    return null;
  }

  return (
    <div className={classNames("legalText uitk-type-200 uitk-type-center", className)}>
      <LocalizedText message={locKeys.hotelLegalDisclaimer} />
    </div>
  );
};
